<template>
    <ul>
        <li v-for="(row,index) in list" :key="index">
            <slot v-bind:row="row"></slot>
        </li>
        <template v-if="(value||[]).length>defaultShowCount">
            <li class="bottomli" @click.stop="onShowAll" v-if="!showAll">
                共{{(value||[]).length}}行,展开 <i class="el-icon-arrow-down"></i>
            </li>
            <li class="bottomli" @click.stop="onShowMore" v-else>收起 <i class="el-icon-arrow-up"></i></li>
        </template>
    </ul>
</template>

<script>
export default {
    name: 'elShowMore',
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        defaultShowCount: {
            type: Number,
            default: 4,
        },

    },
    data() {
        return {
            showAll: false,
        }
    },
    computed: {
        list() {
            if (this.showAll) return this.value || [];
            return (this.value || []).slice(0, this.defaultShowCount);
        },

    },
    methods: {
        onShowAll() {
            this.showAll = true;

            if (document.createEvent) {
                var myEvent = new Event('resize');
                window.dispatchEvent(myEvent);
            } else if (document.createEventObject) {
                window.fireEvent("onresize");
            }
        },
        onShowMore() {
            this.showAll = false;

            if (document.createEvent) {
                var myEvent = new Event('resize');
                window.dispatchEvent(myEvent);
            } else if (document.createEventObject) {
                window.fireEvent("onresize");
            }
        },
    }

}
</script>

<style lang="scss" scoped>
.bottomli {
    text-align: center;
    color: blue;
    font-size: 12px;
    cursor: pointer;
}
</style>